import type { SupportedLocaleMap } from '@zep-us/i18n';

type CmsRequiredLocale = 'ko' | 'en' | 'ja';
export type CmsLocaleMap = SupportedLocaleMap<CmsRequiredLocale>;
export type CmsContentId = string | CmsLocaleMap;

export function resolveContentId(
  contentId: CmsContentId,
  locale: string,
): string {
  if (typeof contentId === 'string') return contentId;
  const localized = contentId[locale as keyof CmsLocaleMap];
  return localized ?? contentId.en;
}
